// extracted by mini-css-extract-plugin
export default {"botaoPrincipal":"BotaoPrincipal_botaoPrincipal__oMrT4","lg":"BotaoPrincipal_lg__sce17"};